import { render } from "./XHeader.vue?vue&type=template&id=8ab6c3f0&scoped=true"
import script from "./XHeader.vue?vue&type=script&lang=js"
export * from "./XHeader.vue?vue&type=script&lang=js"

import "./XHeader.vue?vue&type=style&index=0&id=8ab6c3f0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab6c3f0"]])

export default __exports__